import styled from "styled-components";

export const Container = styled.button`
  border: none;
  background: ${({ selected }) => (selected ? "#90CBF0" : "#e7e7e7")};

  color: ${({ selected }) => (selected ? "#071242" : "#787878")};
  font-weight: 600;
  font-size: 12px;

  max-width: 237px;
  min-width: 90px;
  width: fit-content;
  height: 30px;

  border-radius: 5px;
  padding: 0 5px;

  margin: 5px;
`;
